import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useSelector} from 'react-redux';
import {Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Checkbox} from '@mui/material';
import {findCode, fullCopy, printVariable} from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import {useMediaQuery, useTheme} from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import {Fragment} from 'react';
import moment from 'moment';
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
import MyTableHead from '@components/MyTableHead';
import ConfirmDialog from "@components/ConfirmDialog";
import {Grid} from "@mui/material/";
import {IMask} from "react-imask";
import {NumericFormat} from "react-number-format";
import PropTypes from "prop-types";
import useAlert from "@hooks/useAlert";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const TeacherRegiPartBill = ({record, open, onClose, reload}) => {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()
  const theme = useTheme()
  const [studentList, set_studentList] = React.useState([])
  const [feeList, set_feeList] = React.useState([])
  const [billList, set_billList] = React.useState([])
  const [originBillList, set_originBillList] = React.useState([])
  // redux
  const codes = useSelector(state => state.codeReducer);
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const [fields, set_fields] = React.useState([])

  const defFields = [
    { field: "studentId", placeholder: "ID", visible: false },
    { field: "name", placeholder: "이름", visible: true },
  ]
  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return
    } else {
      onClose()
    }
  }

  const onLoad = async () => {
    openIndicator()
    const report = await fetchBills()
    const fees = report[0]?.fees ??  []
    set_feeList(fees)
    //
    const newFields = [...defFields]
    for (const fee of fees) {
      let feeLabel = findCode(codes, 'SA21', fee.feeCode)?.name ?? ''
      feeLabel = `${feeLabel}(${fee.price})`
      const d = {
        placeholder: feeLabel,
        field: ''+fee.id,
        visible: true,
        type: 'feeId'
      }
      newFields.push(d)
    }
    newFields.push({placeholder: '결제완료여부',field:'finYn', visible:true, type:'checkbox'})

    const billList = []
    if(report[0]) {
      if(report[0].students) {
        set_studentList(fullCopy(report[0].students))
        report[0].students.sort((a, b) => 
          a.grade - b.grade || 
          a.className.localeCompare(b.className) || 
          a.classNum - b.classNum
        )
        for (const stdnt of report[0].students) {
          const d = {studentId: stdnt.id, name: `${stdnt.name} (${stdnt.grade}/${stdnt.className}/${stdnt.classNum})` }
          for (const bill of stdnt.bills) {
            d[''+bill.feeId] = bill.pmt
            d.finYn = bill.finYn
          }
          billList.push(d)
        }
      }
    }


    set_fields(newFields)
    set_billList(billList)
    set_originBillList(fullCopy(billList))

    closeIndicator()
  }

  const fetchBills = async () => {
    const url = `/bill/lecture/${record.id}`
    const resp = await WebService.get(url)

    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const report = JSON.parse(repMessage.report)
      return report
    } else {
      openSnackbar(resp.repMessage)
      return []
    }
  }

  React.useEffect(() => {
    if (open) {
      onLoad()
    }
  }, [open])


  const onSubmit = async() => {
    const billRows = []
    const now = moment().format(dateFormat)
    for(const bill of billList) {
      for(const fee of feeList) {
        const pmt = bill[''+fee.id]
        printVariable('pmt', pmt)
        if(pmt != undefined) {
          printVariable('pmt2', pmt)
          const bills = studentList.find(s => +s.id === +bill.studentId).bills
          const orgRow = bills.find(b => +b.feeId === +fee.id)

          const row = {id:orgRow.id, feeId: fee.id, studentId: bill.studentId, pmt: pmt, finYn:bill.finYn, statCode:orgRow.statCode, uptTime: now, regTime:orgRow.regTime}
          billRows.push(row)
        }

      }
    }

    const url = `/bill/pmt/${schola.id}/${record.id}`
    const resp = await WebService.post(url, billRows)
    if(resp.repCode === 'ack') {
      set_originBillList(fullCopy(billList))
      openSnackbar('저장되었습니다.')
    }
    else {
      alert(resp.repMessage)
    }
  }

  return (
    <Fragment>

      <Dialog open={open} onClose={handleClose} maxWidth='lg' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            <b>{record.title}</b> 강좌 결제 목록
          </Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>

          <MUITable>
            <MyTableHead>
              <TableRow>
                {
                  fields.map((col, index) => {

                    if (col.visible) {
                      return (
                        <TableCell key={index} >
                          {col.placeholder}
                        </TableCell>
                      )
                    }
                  })
                }
              </TableRow>
            </MyTableHead>
            <TableBody>
              {
                billList.map((row, rowIndex) => {
                  return (
                    <TableRow key={rowIndex}>
                      {
                        fields.map((col, colIndex) => {
                          if (col.visible) {
                            if(col.type === 'feeId') {
                              return (
                                <TableCell size='small'>
                                  <TextField defaultValue={row[col.field]}
                                             value={row[col.field]}
                                             InputProps={{
                                               inputProps: {
                                                 style: { textAlign: "right" },
                                               },
                                               inputComponent: NumericFormatCustom,
                                             }}
                                             onChange={(e) => {
                                                row[col.field] = e.target.value
                                                // don't change state
                                             }}
                                  />
                                </TableCell>
                              )
                            }
                            else if(col.type === 'checkbox' && col.field === 'finYn') {
                              return(
                                <TableCell>
                                  <Checkbox checked={row[col.field] === 'Y'} onChange={e => {
                                    const newBillList = [...billList]
                                    // newBillList.find(r => r === row)[col.field]
                                    if(e.target.checked) {
                                      for(const fee of feeList) {
                                        newBillList[rowIndex][''+fee.id] = fee.price
                                      }
                                    }
                                    else {
                                      for(const fee of feeList) {
                                        newBillList[rowIndex][''+fee.id] = originBillList[rowIndex][''+fee.id]
                                      }
                                    }

                                    newBillList[rowIndex][col.field] = row[col.field] === 'Y' ? 'N' : 'Y'
                                    set_billList(newBillList)

                                  }}/>
                                </TableCell>
                              )
                            }
                            else {
                              return (
                                <TableCell size='small'>{row[col.field]}</TableCell>
                              )
                            }
                          }
                        })
                      }
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </MUITable>
        </DialogContent>
        <DialogActions style={{display:'flex', justifyContent:'center'}}>
          <Button variant='outlined' onClick={()=> {
            handleClose()
            reload()
          }}>
            닫기
          </Button>
          <ConfirmDialog
            btn={<Button  variant='contained'>저장</Button>}
            title={'결제 정보'}
            content={'결제 정보를 저장하시겠습니까?'}
            bc={'primary'}
            perform={() => onSubmit()}
          />
        </DialogActions>
      </Dialog>

      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default TeacherRegiPartBill
